import { axiosInstance } from "@/config/NetworkUtility";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";

export const setAuthToken = (token, email = '', name = '', userData = {}) => {
    if (token) {
        localStorage.setItem('authToken', token);
        // Store as array for backward compatibility with [authUser] destructuring across the app
        const userArray = Array.isArray(userData) ? userData : [userData];
        localStorage.setItem('authUser', JSON.stringify(userArray));
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        delete axiosInstance.defaults.headers.common['Authorization'];
    }
};

export function deepClone(value){
  return JSON.parse(JSON.stringify(value));
};

export const downloadPDF = async (printRef,title,  setDownloading=()=>{}) => {
        if (!printRef?.current) return;

        try {
        setDownloading(true)
            const canvas = await html2canvas(printRef.current, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff'
            });

            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'mm',
                format: 'a4'
            });

            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = canvas.width;
            const imgHeight = canvas.height;
            const ratio = imgWidth / imgHeight;

            let width = pageWidth - 20;
            let height = width / ratio;

            if (height > pageHeight - 20) {
                height = pageHeight - 20;
                width = height * ratio;
            }

            const x = (pageWidth - width) / 2;
            const y = (pageHeight - height) / 2;

            pdf.addImage(imgData, 'PNG', x, y, width, height);
            pdf.save(`${title || 'Document'}_${moment().format('YYYY-MM-DD')}.pdf`);

           
        } catch (error) {
            console.error('Error generating PDF:', error);

        }finally {
  setDownloading(false);
}
    };